/**
 * @generated SignedSource<<af9311737efdf92a74b880d8dafff7c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserBrandRegistrationRequestInput = {
  clientMutationId?: string | null | undefined;
  email: string;
  formId: string;
};
export type RegistrationMutation$variables = {
  input: UserBrandRegistrationRequestInput;
};
export type RegistrationMutation$data = {
  readonly userBrandRegistrationRequest: {
    readonly ok: boolean;
  } | null | undefined;
};
export type RegistrationMutation = {
  response: RegistrationMutation$data;
  variables: RegistrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserBrandRegistrationRequestPayload",
    "kind": "LinkedField",
    "name": "userBrandRegistrationRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegistrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegistrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0773475738ed3a811cba123f3cadcc6b",
    "id": null,
    "metadata": {},
    "name": "RegistrationMutation",
    "operationKind": "mutation",
    "text": "mutation RegistrationMutation(\n  $input: UserBrandRegistrationRequestInput!\n) {\n  userBrandRegistrationRequest(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "6433960f71e8c39bfa9f55e98189dcc6";

export default node;
